var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_users",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1664",
    "data-name": "Rectangle 1664",
    width: 31.5,
    height: 18.491,
    fill: "#fff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679",
    "data-name": "Rectangle 1679",
    width: 42,
    height: 42,
    fill: "#6639b7",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_users-2",
    "data-name": "icon_users",
    transform: "translate(5.25 11.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3702",
    "data-name": "Groupe 3702",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13532",
    "data-name": "Trac\\xE9 13532",
    d: "M51.559,57.273a8.229,8.229,0,0,0-6.863-3.3,8.228,8.228,0,0,0-6.862,3.3,1.963,1.963,0,0,0,1.623,3.07h10.48a1.972,1.972,0,0,0,1.623-3.07",
    transform: "translate(-29.074 -41.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13533",
    "data-name": "Trac\\xE9 13533",
    d: "M102.464,0a3.6,3.6,0,1,1-3.605,3.605A3.6,3.6,0,0,1,102.464,0",
    transform: "translate(-76.662 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13534",
    "data-name": "Trac\\xE9 13534",
    d: "M12.665,0A3.6,3.6,0,1,1,9.06,3.605,3.6,3.6,0,0,1,12.665,0",
    transform: "translate(-7.026 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13535",
    "data-name": "Trac\\xE9 13535",
    d: "M102.269,44.374a6.511,6.511,0,0,0-5.431-2.615A6.613,6.613,0,0,0,91.605,44.1a8.714,8.714,0,0,1,3.147,2.7h6.233a1.561,1.561,0,0,0,1.284-2.429",
    transform: "translate(-71.037 -32.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13536",
    "data-name": "Trac\\xE9 13536",
    d: "M10.854,44.01h0c-.023-.028-.048-.055-.072-.083s-.071-.084-.108-.124-.077-.082-.116-.122-.078-.081-.119-.12-.082-.077-.124-.115-.085-.077-.128-.115-.088-.073-.133-.109-.089-.072-.135-.107-.1-.07-.144-.1-.092-.066-.14-.1-.1-.067-.157-.1-.093-.059-.141-.088-.114-.065-.172-.1-.093-.052-.14-.077-.125-.062-.189-.092c-.046-.022-.091-.045-.137-.066-.068-.031-.137-.059-.206-.087-.044-.018-.088-.037-.132-.055-.074-.029-.15-.055-.225-.081-.042-.015-.083-.03-.125-.044-.081-.026-.163-.05-.245-.074l-.117-.034c-.089-.024-.179-.045-.269-.066l-.1-.024c-.1-.021-.195-.038-.293-.055L6.9,41.853c-.106-.017-.213-.03-.321-.043L6.505,41.8c-.122-.013-.246-.022-.37-.029l-.029,0q-.2-.011-.405-.011h0A6.511,6.511,0,0,0,.268,44.374,1.515,1.515,0,0,0,0,45.192a1.548,1.548,0,0,0,1.441,1.6c.037,0,.073.008.11.008H7.784a8.714,8.714,0,0,1,3.147-2.7c-.025-.032-.052-.062-.077-.093",
    transform: "translate(0 -32.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13537",
    "data-name": "Trac\\xE9 13537",
    d: "M53.944,1.552a4.517,4.517,0,1,1-4.517,4.517,4.51,4.51,0,0,1,4.517-4.517",
    transform: "translate(-38.329 -1.203)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon_users.eb1a1817cb58823f0d2a5be4ad597e60.svg";
export { ForwardRef as ReactComponent };